import { render, staticRenderFns } from "./CompositeObjectControl.vue?vue&type=template&id=087bf974&"
import script from "./CompositeObjectControl.vue?vue&type=script&lang=js&"
export * from "./CompositeObjectControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports